import MailListItemDataProps from '../utils/types/MailListItemDataProps';
import MailListTableProps from '../utils/types/MailListTableProps';
import { observer } from 'mobx-react';
import { highlightTermsInHtmlElement } from 'owa-highlight';
import getMeetingItem from 'owa-meeting-message/lib/utils/getMeetingItem';
import shouldMeetingItemShowRSVP from 'owa-listview-rsvp/lib/utils/shouldMeetingItemShowRSVP';
import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';
import renderMeetingPreviewPlaceHolder from './MailListItemMeetingPreviewPlaceholder';
import * as React from 'react';

const styles = require('./MailListItem.scss');
export interface MailListItemMeetingPreviewProps {
    mailListTableProps: MailListTableProps;
    mailListItemDataProps: MailListItemDataProps;
    originalPreview: string;
}

@observer
export default class MailListItemMeetingPreview extends React.Component<
    MailListItemMeetingPreviewProps,
    any
> {
    private highLightTerms = (element: HTMLElement) => {
        highlightTermsInHtmlElement(element, this.props.mailListTableProps.highlightTerms);
    };

    private renderMeetingPreview(): JSX.Element {
        const meetingItem = getMeetingItem(this.props.mailListItemDataProps.latestItemId);

        // The item is not on store yet or does not have all the properties we need
        if (!meetingItem) {
            return renderMeetingPreviewPlaceHolder();
        }

        // Checks if this meeting item will be shown, othewise fallback to original preview
        if (!shouldMeetingItemShowRSVP(meetingItem)) {
            return (
                <span className={styles.previewDisplayText} ref={this.highLightTerms}>
                    {this.props.originalPreview}
                </span>
            );
        }

        return (
            <>
                <span className={styles.previewDisplayText} ref={this.highLightTerms}>
                    {formatMeetingTimeSpan(
                        meetingItem.Start,
                        meetingItem.End,
                        !meetingItem.RecurrenceId /* ideally we would check CalendarItemType but it seems broken */
                            ? meetingItem.Recurrence
                            : undefined /* recurrenceId indicates instance */,
                        true // short string
                    )}
                </span>
            </>
        );
    }

    render() {
        return this.renderMeetingPreview();
    }
}
